import { Link } from "gatsby";

export default {
    colors: {
        text: `black`,
        background: `white`,
        primary: `#ee4466`,
        secondary: `##ee4466`
    },   
    fonts: {
        heading: "system-ui",
        body: "system-ui",
    }
}